module.exports = __webpack_public_path__ + "img/uni-img.f55b013d.png";